// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderLogo_root__W4ce9"};